import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { TabProfile, TabType } from 'src/app/services/API.service';
import { TabForm } from '../../models/forms/tab-form';

@Component({
  selector: 'app-tab-manager',
  templateUrl: './tab-manager.component.html',
  styleUrls: ['./tab-manager.component.css']
})
export class TabManagerComponent implements OnInit {
  @Input() Tabs: FormGroup[]
  @Input() Email: string[] = [];
  @Input() Defaults: string[] = [];
  @Output() changes = new EventEmitter<FormGroup>();
  @Output() delete = new EventEmitter<string>();
  selected;
  

  constructor(private fb: FormBuilder) {

  }

  ngOnInit(): void {

  }

  onAddTab() {

    if (this.selected) {
      var index = this.Tabs.findIndex(n => n.get('Type').value == TabType.Default && n.get('RecordKey').value == this.selected);

      if (index >= 0) {
        this.Tabs.push(this.copyTab(this.Tabs[index]));

        this.selected = null;
      }
    }
  }

  onSaveTab(index) {
    if (this.Tabs[index].dirty) {
      this.changes.emit(this.Tabs[index]);
      this.Tabs[index].markAsPristine();
    }
  }

  onDeleteTab(index) {
    var id = this.Tabs[index].get('id').value;
    
    if (this.defaultCount() == 1) {
      return;
    }
    
    if (id) {
      this.delete.emit(this.Tabs[index].get('id').value);
    }
    
    this.Tabs.splice(index, 1);
  }

  copyTab(tab: FormGroup): FormGroup {
    var table = tab.get('Table').value;
    var note = tab.get('Note').value;

    var rec: TabProfile = {
      __typename: 'TabProfile',
      id: null,
      Title: 'New Tab',
      UserID: null,
      Type: TabType.Standard,
      RecordKey: tab.get('RecordKey').value,
      ExclusionList: tab.get('ExclusionList').value,
      Table: {
        __typename:'TableProfile',
        PageSizeOptions: table['PageSizeOptions'],
        Columns: table['Columns']
      },
      Note: {
        __typename: 'NoteProfile',
        NotesTitle: note['NotesTitle'],
        DropTitle: note['DropTitle'],
        DropDownEntries: note['DropDownEntries']
      }
    };

    rec.Table.Columns.unshift({
      __typename: "ColumnProfile",
      HeaderTxt: 'Select',
      Field: 'select'
    });

    return this.fb.group(new TabForm(rec, this.fb));
  }

  defaultCount(): number {
    var count: number = 0;

    this.Tabs.forEach(n => {
      if (n.get('Type').value == TabType.Default) {
        count += 1;
      }
    });

    return count;
  }
}
